const HERO_IMAGE =
  "https://images.unsplash.com/photo-1524309784716-6a4be8299c7f?w=2400&q=85";

export default function HeroBackdrop() {
  return (
    <>
      <div
        className="absolute inset-0 animate-kenburns"
        style={{
          backgroundImage: `url('${HERO_IMAGE}')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/20 to-black/70" />
    </>
  );
}
